import { ReactElement } from "react";

export default function LandingHeader(): ReactElement {
  return (
    <div className="front-navbar">
      <a href="https://varist.com" target="_blank" rel="noopener noreferrer">
        <img src="/svgg.svg" alt="Varist logo" className="front-logo" />
      </a>
      <span className="front-title-container">
        <h1 className="front-title-text" id="h1-title">
          VARIST
        </h1>{" "}
        <h1 className="front-title-text-white" id="h1-title">
          Community
        </h1>
      </span>
      <p className="front-text">
        Advanced malware detection through behavioral analysis.
      </p>
      <p className="front-powered-by">
        Powered by{" "}
        <a
          href="https://varist.com"
          target="_blank"
          rel="noopener noreferrer"
          className="varist-link"
        >
          Varist
        </a>
      </p>
    </div>
  );
}
